import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ProductsListMapperI } from '../../models/products-list/products-list';
import {MatSort, Sort} from '@angular/material/sort';
import { MatCheckbox } from '@angular/material/checkbox';
import { Router } from '@angular/router';

@Component({
  selector: 'anterasoftware-kanban-product-thumbnail-view',
  templateUrl: './kanban-product-thumbnail-view.component.html',
  styleUrls: ['./kanban-product-thumbnail-view.component.scss']
})
export class KanbanProductThumbnailViewComponent implements OnInit {

  @Input() public products: any[] = [];
  @Input() public pageSizeOptions: number[] = [];
  @Input() public totalCount: number = 0;
  @Input() public page: string = '';

  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onColumnClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPaginateFire: EventEmitter<any> = new EventEmitter();
  @Output() public onSortFired: EventEmitter<any> = new EventEmitter();
  @Output() public onAutoUpdateToggled: EventEmitter<any> = new EventEmitter();
  @Output() public onGoto: EventEmitter<any> = new EventEmitter();

  public selectAll: boolean = false;
  public pageSize: number = 50;

  constructor(
    private router: Router
  ) { 
   
   console.log("anterasoftware-kanban-product-thumbnail-view","KanbanProductThumbnailViewComponent")
   console.log("KanbanProductThumbnailViewComponent constructor",this.products)
  }

  ngOnInit(): void {

    console.log("KanbanProductThumbnailViewComponent ngOnInit",this.products)
  }

  public paginate(event: any) {
    const paginateObj = {
      offset: event.pageIndex,
      limit: event.pageSize,
    };

    this.pageSize = event.pageSize;
    this.onPaginateFire.emit(paginateObj);
  }

  public onColumnClicked(element: ProductsListMapperI, columnName: string): void {
    this.onColumnClick.emit({ columnName, rowSelected: element });
  }

  public toggleAll(event:any, selectType: string, checkbox?: MatCheckbox, selectedRow?: ProductsListMapperI): void {
    
    console.log("toggle product")
    switch (selectType){
      case 'SINGLE':
        this.products.find((row: ProductsListMapperI) => row.id === selectedRow?.id).select = checkbox?.checked;
        break;
      case 'FIRST_50':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.products.forEach((data: ProductsListMapperI) => (data.select = true));
        break;
      case 'SELECT_ALL':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.products.forEach((data: ProductsListMapperI) => (data.select = true));
        break;
      case 'DESELECT_ALL':
        this.selectAll = false;
        this.products.forEach((data: ProductsListMapperI) => (data.select = false));
        break;
      case 'SELECT_ALL_TOGGLE':
        this.selectAll = !this.selectAll;
        this.products.forEach((data: ProductsListMapperI) => (data.select = this.selectAll));
        selectType = this.selectAll ? 'SELECT_ALL' : 'DESELECT_ALL';
        break;
      default:
        this.selectAll = !this.selectAll;
        this.products.forEach((data: ProductsListMapperI) => (data.select = this.selectAll));
        break;
    }

    this.selectClicked.emit({data: this.products, selectType});
  }

  public onListViewSort(event: Sort) {
    this.onSortFired.emit(event);
  }

  public goto(productId:number) {
    this.onGoto.emit(productId);
  }

  public autoUpdateToggled(ev:any, product:any) {
    ev.stopPropagation();
    this.onAutoUpdateToggled.emit(product);
  }
} 
